import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../utils/api";

export default function ItemMasterView() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [row, setRow] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/api/item-master/${id}`);
        setRow(res.data);
      } catch (err) {
        alert(err?.response?.data?.error || err.message || "Load failed");
      }
    })();
  }, [id]);

  if (!row) return <div className="p-3">Loading...</div>;

  return (
    <div className="container-fluid p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">View Item Master</h2>

        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate("/item-master")}
        >
          Close
        </button>
      </div>

      <div className="card">
        <div className="card-body row g-3">
          <div className="col-md-4">
            <label className="form-label">ID</label>
            <input className="form-control" value={row.id || ""} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Item Code</label>
            <input
              className="form-control"
              value={row.item_code || ""}
              readOnly
            />
          </div>

          <div className="col-md-6">
            <label className="form-label">Item Name</label>
            <input
              className="form-control"
              value={row.item_name || ""}
              readOnly
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Item Type</label>
            <input
              className="form-control"
              value={row.item_type || ""}
              readOnly
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Unit Name</label>
            <input
              className="form-control"
              value={row.unit_name || ""}
              readOnly
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Active</label>
            <input
              className="form-control"
              value={Number(row.is_active) === 1 ? "Yes" : "No"}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
}